export default __webpack_public_path__ + "static/media/1880.bf026417.png";